var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 pl-0 pr-0"},[_c('GChart',{attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.chartOptions,"resizeDebounce":500}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }